import * as actionType from '../actions/actionTypes';
const initialState = {
  consoleUsers: [],
  consoleUserSuggestions: [],
  userSuggestions: [],
  users: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case actionType.CONSOLE_USERS_HISTORY:
      return {
        ...state,
        consoleUsers: action.payload,
      }
    case actionType.USERS_HISTORY:
      return {
        ...state,
        users: action.payload
      }
    case actionType.LOGIN_HISTORY:
        return {
          ...state,
          logs: action.payload
        }
    case actionType.USER_LOGIN_HISTORY:
          return {
            ...state,
            userlogs: action.payload
          }
    case actionType.CONSOLE_USERS_SUGGESTION:
      return {
        ...state,
        consoleUserSuggestions: action.payload
      }
    case actionType.USERS_SUGGESTION:
      return {
        ...state,
        userSuggestions: action.payload
      }
    default:
      return state;
  }
}

